import { render } from "./filter-search-filters.vue?vue&type=template&id=023a1c65"
import script from "./filter-search-filters.vue?vue&type=script&lang=js"
export * from "./filter-search-filters.vue?vue&type=script&lang=js"

import "./filter-search-filters.vue?vue&type=style&index=0&id=023a1c65&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__